import Cookies from 'js-cookie';

import { parseJwtCliengo } from './jwt-parser';
import { JwtCliengoPayload } from './types';

import { mockedJwt } from '@/__mocks__/services/auth/data';
import { LOGIN_URL, MOCKED_AUTH } from '@/constants/environment';
import { getHsmWebsites } from '@/services/hsm-backend';
import { HsmWebsite } from '@/services/hsm-backend/types';

/**
 * Redirects to login URL
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function redirectToLogin(): void {
  const currentURL = window.location.href;

  window.location.href = `${LOGIN_URL}?redirect=${currentURL}`;
}

/**
 * Validates the authenticity of a Cliengo JWT trying to get the websites.
 * @param jwt the JWT set in the Cookies
 * @param onAuthenticationVerified a Callback to call if the token is correct
 * @returns true in case the token is correct
 */
async function verifyAuthToken(
  jwt: string,
  onAuthenticationVerified: (jcp: JwtCliengoPayload, ws: HsmWebsite[]) => void
): Promise<boolean> {
  let websites: HsmWebsite[] | null = null;

  try {
    const payload: JwtCliengoPayload | undefined = parseJwtCliengo(jwt);

    if (payload) {
      websites = await getHsmWebsites(jwt);

      onAuthenticationVerified(payload, websites);
      return true;
    }
  } catch (e) {}
  return false;
}

/**
 * Verify if the JWT in cookies is valid.
 * Redirects to login in case of invalid JWT.
 * @param onAuthenticationVerified a Callback to call when the token is correct
 */
export async function validateJwtAndAuthorize(
  onAuthenticationVerified: (jcp: JwtCliengoPayload, ws: HsmWebsite[]) => void
): Promise<void> {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const jwt: string | undefined = MOCKED_AUTH ? mockedJwt : Cookies.get('jwt');

  if (!jwt) {
    // TODO: Uncomment this
    // redirectToLogin();
    return;
  }

  const result = await verifyAuthToken(jwt, onAuthenticationVerified);

  if (result) {
    return;
  }
  // TODO: Uncomment this
  // redirectToLogin();
}
